















import { defineComponent, onBeforeUnmount } from "@vue/composition-api";
import { lockBodyScroll } from "@scrile/tools/dist/lib/Scrollhelpers";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import BaseIconButton from "@/components/BaseIconButton";

export default defineComponent({
  name: "StoriesModal",
  components: { BaseIconButton },
  setup() {
    lockBodyScroll(true);

    onBeforeUnmount(() => {
      lockBodyScroll(false);
      emitter.emit(EVENTS.STATUS_HIDE);
    });
  },
});
